<template>
  <div style="background-color: #2d6ee8">
    <el-row class="header">
      <el-col :span="16">
        <div class="logo">{{sysName}}投审稿系统</div>
        <div class="pageName">{{ pageName }}</div>
      </el-col>

      <el-col :span="8">
        <ul id="qLink">
          <li><router-link class="forgot" to="/login">登录</router-link></li>
        </ul>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import systemApi from "@/api/system"
export default {
  name: "Header",
  props: {
    pageName: {
      type: String,
      required: true,
    },
  },
  data(){
    return {
      sysName:'',
    }
  },
  mounted() {
    this.initSetting()
  },
  methods:{
    initSetting() {
      systemApi.getName().then((res) => {
        this.sysName = res.data
      })
    },
  }
};
</script>

<style lang="scss" scoped>

</style>
